/* Rediscover — footer country / language / currency selector (Loewe-style, 2026-09-26).
   Markup: snippets/rediscover-shipto.liquid; styles: assets/rediscover-shipto.css.
   A language click applies at once; a country click STAGES the choice (heading, languages,
   currency and button follow) and the black button submits Shopify's own localization form. Languages are rebuilt from the picked country's data-langs, because each
   market publishes its own set (US = English only, France = Français + English). */
(function () {
  function init() {
    var root = document.querySelector('[data-rdv-shipto]');
    if (!root || root.dataset.rdvBound) return;
    root.dataset.rdvBound = '1';

    var form = root.querySelector('.rdv-shipto__form');
    var cInput = root.querySelector('[data-rdv-input]');
    var lInput = root.querySelector('[data-rdv-lang-input]');
    var ret = root.querySelector('[data-rdv-return]');
    var panel = root.querySelector('[data-rdv-panel]');
    var heading = root.querySelector('[data-rdv-country-heading]');
    var langList = root.querySelector('[data-rdv-langs]');
    var ccy = root.querySelector('[data-rdv-ccy]');
    var submit = root.querySelector('[data-rdv-submit]');
    var shopIn = root.getAttribute('data-shop-in') || '';
    var shippingTo = root.getAttribute('data-shipping-to') || '';

    var state = {
      country: root.querySelector('.rdv-shipto__country.is-active'),
      lang: lInput ? lInput.value : '',
      langName: (root.querySelector('.rdv-shipto__lang.is-active') || {}).textContent || ''
    };

    function open() {
      root.classList.add('is-open');
      document.body.classList.add('rdv-shipto-lock');
      if (panel) panel.setAttribute('aria-hidden', 'false');
      /* every continent starts closed (Loewe), so Language and Currency stay in view */
    }
    function close() {
      root.classList.remove('is-open');
      document.body.classList.remove('rdv-shipto-lock');
      if (panel) panel.setAttribute('aria-hidden', 'true');
    }
    function setGroup(g, on) {
      g.setAttribute('data-open', on ? 'true' : 'false');
      var b = g.querySelector('[data-rdv-acc]');
      if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false');
    }
    function mark(list, btn) {
      list.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    function refresh() {
      var c = state.country;
      if (!c) return;
      var name = c.getAttribute('data-name');
      if (heading) heading.textContent = shippingTo + ' ' + name;
      if (ccy) ccy.textContent = c.getAttribute('data-ccy') + ' ' + c.getAttribute('data-sym');
      if (submit) submit.textContent = shopIn + ' ' + name + ' (' + state.langName + ')';
      if (cInput) cInput.value = c.getAttribute('data-value');
      if (lInput) lInput.value = state.lang;
    }
    function langButton(code, name) {
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'rdv-shipto__opt rdv-shipto__lang';
      b.setAttribute('data-value', code);
      b.setAttribute('data-name', name);
      b.setAttribute('lang', code);
      b.textContent = name;
      li.appendChild(b);
      return li;
    }
    function bindLangs() {
      var btns = Array.prototype.slice.call(langList.querySelectorAll('.rdv-shipto__lang'));
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          state.lang = b.getAttribute('data-value');
          state.langName = b.getAttribute('data-name');
          mark(btns, b);
          refresh();
          /* a language pick applies at once (Gijs 2026-09-26: "it doesn't immediately work"),
             together with whatever country is staged; only a country pick waits for the button */
          if (ret) ret.value = window.location.pathname + window.location.search;
          if (form.requestSubmit) form.requestSubmit(); else form.submit();
        });
      });
      var cur = btns.filter(function (b) { return b.getAttribute('data-value') === state.lang; })[0];
      mark(btns, cur);
    }
    function rebuildLangs(c) {
      var raw = c.getAttribute('data-langs') || '';
      var langs = raw.split('|').filter(Boolean).map(function (p) {
        var i = p.indexOf(':');
        return { code: p.slice(0, i), name: p.slice(i + 1) };
      });
      if (!langs.length) return;
      /* keep the staged language when the new country offers it, else its market default (first) */
      var keep = langs.filter(function (l) { return l.code === state.lang; })[0] || langs[0];
      state.lang = keep.code;
      state.langName = keep.name;
      langList.innerHTML = '';
      langs.forEach(function (l) { langList.appendChild(langButton(l.code, l.name)); });
      bindLangs();
    }

    root.querySelector('[data-rdv-open]').addEventListener('click', open);
    root.querySelector('[data-rdv-close]').addEventListener('click', close);
    root.querySelector('[data-rdv-overlay]').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    root.querySelectorAll('[data-rdv-acc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var g = btn.closest('.rdv-shipto__group');
        setGroup(g, g.getAttribute('data-open') !== 'true');
      });
    });

    var countries = Array.prototype.slice.call(root.querySelectorAll('.rdv-shipto__country'));
    countries.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.country = btn;
        mark(countries, btn);
        rebuildLangs(btn);
        refresh();
      });
    });
    if (langList) bindLangs();

    form.addEventListener('submit', function () {
      refresh();
      if (ret) ret.value = window.location.pathname + window.location.search;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
